import React from 'react';

import {RunColorOptions} from '../types';
import {SemanticLegendBuckets} from './SemanticLegendBuckets';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from './SemanticLegendDefaults';
import {SemanticLegendExcludedRunColor} from './SemanticLegendExcludedRunColor';
import {SemanticLegendMetric} from './SemanticLegendMetric';
import {SemanticLegendNumBuckets} from './SemanticLegendNumBuckets';
import {SemanticLegendRunColorOptions} from './SemanticLegendRunColorOptions';
import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsContextProvider';
import {SemanticLegendYValue} from './SemanticLegendYValue';

export const SemanticLegendColorTab = () => {
  const {
    semanticLegendSettings,
    semanticLegendRunColorOptions,
    updateSemanticLegendRunColorOptions,
    createOrUpdateSemanticLegendSettings,
  } = useSemanticLegendSettingsContext();

  const {hasActiveGrouping} = useSemanticLegendSettingsContext();
  const showMetricBasedColors =
    !hasActiveGrouping &&
    semanticLegendRunColorOptions === RunColorOptions.MetricBasedColors;

  return (
    <div
      data-test="workspace-semantic-legend-color-settings"
      className={'flex h-full w-full flex-col gap-20 py-16'}>
      <SemanticLegendRunColorOptions
        hasActiveGrouping={hasActiveGrouping}
        runColorOptions={
          semanticLegendRunColorOptions ?? RunColorOptions.OriginalProjectColors
        }
        onRunColorOptionsChange={value => {
          updateSemanticLegendRunColorOptions?.(value);
        }}
      />
      {showMetricBasedColors && (
        <SemanticLegendMetric
          metric={semanticLegendSettings?.metric ?? ''}
          updateSetting={value => {
            createOrUpdateSemanticLegendSettings?.({
              ...semanticLegendSettings,
              ...value,
            });
          }}
        />
      )}
      {showMetricBasedColors &&
        semanticLegendSettings?.metric &&
        semanticLegendSettings?.metric !==
          DEFAULT_SEMANTIC_LEGEND_SETTINGS.metric && (
          <div className={'flex h-full w-full flex-col'}>
            <SemanticLegendYValue
              yValue={
                semanticLegendSettings?.yAxisValue ??
                DEFAULT_SEMANTIC_LEGEND_SETTINGS.yAxisValue
              }
              updateSetting={value => {
                createOrUpdateSemanticLegendSettings?.({
                  ...semanticLegendSettings,
                  ...value,
                });
              }}
            />
            <SemanticLegendNumBuckets
              numberOfBuckets={semanticLegendSettings?.numberOfBuckets ?? 0}
              updateSetting={value => {
                createOrUpdateSemanticLegendSettings?.({
                  ...semanticLegendSettings,
                  ...value,
                });
              }}
            />
            <SemanticLegendBuckets
              bucketCustomizations={
                semanticLegendSettings?.bucketCustomizations ?? {}
              }
              buckets={semanticLegendSettings?.buckets ?? []}
              updateSetting={value => {
                createOrUpdateSemanticLegendSettings?.({
                  ...semanticLegendSettings,
                  ...value,
                });
              }}
            />
            <SemanticLegendExcludedRunColor
              excludedRunColor={semanticLegendSettings?.excludedRunColor ?? ''}
              updateSetting={value => {
                createOrUpdateSemanticLegendSettings?.({
                  ...semanticLegendSettings,
                  ...value,
                });
              }}
            />
          </div>
        )}
    </div>
  );
};
